// 封装的用户相关的方法。
// import typeUtils from '@/common/typeUtils'
import commonUtils from '@/common/commonUtils'
import {Dialog, Toast} from 'vant'
import Vue from 'vue'
import {doPost} from "@/common/httpInit";

export default {
  AppKey: 'zqt',
  LoginUserKey: 'loginUser',
  TokenKey: 'token',
  TypeAdmin: '1',  // 管局端
  TypeClient: '2',  // 企业端
  /**
   * 订餐端
   */
  TypeOrder: '3',

  /**
   * 获取网站信息
   * @param thisApp
   * @returns {Promise<{qrLogin,pswLogin,cityCode,siteTitle,adminLoginFooter,bigChartTitle}>}
   */
  getWebSiteInfo(thisApp, config = {}, useStorageCache = false){
    // console.log("getWebSiteInfo");
    return new Promise((resolve) => {
      if(window.webSiteInfo){
        resolve(window.webSiteInfo);
      }else {
        if(useStorageCache){
          const webSiteInfoCache = commonUtils.getStorage("siteInfo");
          if(webSiteInfoCache){
            window.webSiteInfo = webSiteInfoCache;
            resolve(webSiteInfoCache);
            return;
          }
        }
        let defaultData = {
          qrLogin: 0,
          pswLogin: 1,
          cityCode: '',
          siteTitle: "邮政管理局安全监管平台",
          adminLoginFooter: "技术支持：广州万博软件科技有限公司",
          bigChartTitle: "邮政业一张图",
          "mapZoom":"9",
          "mapCenterLngLat":"116.182563,24.269714"
        };
        thisApp.$get('/dic/getSiteInfo', {}, config, 2).then(({data}) => {
          window.webSiteInfo = commonUtils.copyValue(defaultData, data);
          commonUtils.setStorage("siteInfo", window.webSiteInfo);
          resolve(window.webSiteInfo);
        }).catch(()=>{
          const localSiteInfo = commonUtils.getStorage("siteInfo");
          if(localSiteInfo) {
            resolve(JSON.parse(localSiteInfo));
          }else {
            resolve(defaultData);
          }
        })
      }
    });
  },
  // setToken(token){
  //   if(token){
  //     commonUtils.setCookie(this.TokenKey, token);
  //   }else {
  //     commonUtils.setCookie(this.TokenKey, '');
  //     commonUtils.setStorage(this.LoginUserKey, null);
  //     commonUtils.setOpenId('');
  //   }
  // },
  getToken(){
    return commonUtils.getCookie(this.TokenKey);
  },
  /**
   * 去除指定前缀的Token
   * @param {Object} prefix
   */
  clearToken(prefix) {
    var token = this.getToken();
    if (token == null || token == '') {
      return;
    }
    var index = token.indexOf(prefix);
    if (index == 0) {
      this.clearUser();
    }
  },
  /**
   * 获取用户菜单，默认从localStorage中获取，获取不到再请求服务器，用户即出登录时清除localStorage
   * @param thisApp
   * @param config
   * @returns {Promise<[]>}
   */
  getUserMenuTree(thisApp, config = {}){
    return new Promise((resolve) => {
      const user = this.getLoginUser();
      if(user){
        resolve(user.userMenu);
      }else {
        resolve([]);
      }
    })
  },
  /**
   * 获取当前登录用户信息
   * @returns {null|Object} {userInfo: {}, token: "", userMenu: [], type: Number} type 是否可以同时登录管局端和企业端，默认0,不可以，1可以
   */
  getLoginUser(){
    const user = commonUtils.getStorage(this.LoginUserKey);
    if(user && user.token === this.getToken()){
      return user;
    }else {
      this.clearUser();
    }
    return null;
  },
  /**
   * 设置当前登录用户信息
   * @param userObj {userInfo: {}, token: "", userMenu: [], type: Number}
   */
  setLoginUser(userObj){
    if(userObj){
      let user = {
        userInfo: null,
        token: null,
        userMenu: null,
        type: 0,
      };
      commonUtils.copyValue(user, userObj);
      user.userMenu = this.menuListToTree(user.userMenu);
      commonUtils.setStorage(this.LoginUserKey, user);
      // commonUtils.setOpenId(user.userInfo.openId);
      commonUtils.setCookie(this.TokenKey, user.token, 7200);
      // this.setToken(user.token);
    }
  },
  /**
   * 清除当前登录用户
   */
  clearUser(){
    // commonUtils.setCookie(this.TokenKey, '', -1);
    // commonUtils.setStorage(this.LoginUserKey, null);
    this.clearUserAndToken();
    commonUtils.setOpenId('');
  },
  clearUserAndToken(){
    commonUtils.setCookie(this.TokenKey, '', -1);
    commonUtils.setStorage(this.LoginUserKey, null);
  },
  /**
   * 菜单列表转换成菜单树
   * @param menuList
   * id: 24
   name: "专项检查"
   parentId: 21
   router: "/label/special/list"
   icon: "el-icon-s-promotion"
   href: null
   code: "/label/special/list"
   sort: 99
   type:  0 系统目录, 1子系统一级菜单, 2子系统二级菜单, 3子系统二级菜单权限
   hrefType: href链接打开方式 0路由，1本页，2新标签页
   */
  menuListToTree(menuList){
    return this._findChildren(0, menuList);
  },
  _findChildren(parentId, menuList){
    let children = []
    if(menuList){
      for (let item of menuList){
        if(item.parentId === parentId){
          item.children = this._findChildren(item.id, menuList);
          children.push(item);
        }
      }
    }
    return children;
  },
  findSystemByPath(menuTree, path){
    for (let item of menuTree){
      if(item.href === path){
        return item
      }else{
        let m = this.findSystemByPath(item.children, path);
        if(m){
          return item;
        }
      }
    }
    return null;
  },
  goMenu(thisApp, menu){
    console.log("goMenu", JSON.stringify(menu))
    if (menu.href != undefined && menu.href != null && menu.href != "") {
      switch (menu.hrefType) {
        case 2:
          window.open(menu.href, "_blank")
          break;
        case 1:
          window.location.href = menu.href
          break;
        default:
          thisApp.$router.push({
            path: menu.href
          }).catch(err => {
            console.log(err)
          })
          break;
      }
    } else {
      if(menu.type === 0){
        const findIndex = function (menuItem) {
          if(menuItem.href){
            return menuItem.href
          }else if(menuItem.children && menuItem.children.length > 0){
            return findIndex(menuItem.children[0]);
          }
          return '';
        }
        window.location.href = "./main.html" + "#" + findIndex(menu)
      } else {
        alert(" 开发君，努力开发中");
      }
    }
  },
  /**
   * 获取当前项目的城市
   * @returns {Promise<cityCode>}
   */
  getCity(){
    return new Promise((resolve) => {
      this.getWebSiteInfo(window.VmApp).then((data)=>{
        resolve({
          "cityCode":data.cityCode,
          "mapZoom":data.mapZoom,
          "mapCenterLngLat":data.mapCenterLngLat
        });
      })
      // resolve('0769dg') //区号
      //resolve('0753mz')   //梅州区号
    });
  },
  showErr(err){
    Toast.fail(commonUtils.getErrMsg(err));
  },
  logout(thisApp){
    Dialog.confirm({
      title: '提示',
      message: '是否退出当前系统',
    }).then(() => {
      // on confirm
      const token = this.getToken();

      if (token && token !== 'Undefined') {
        thisApp.$get('/logout', null, null, 2).then(() => {
          this.clearUser();
          // this.goLoginPage();
          Toast('已退出登录');
        }).catch((err)=>{
          this.showErr(err);
          console.log("logout err")
          this.checkLogin(thisApp).then(()=>{
            // nothing to do
          }).catch(()=>{
            // nothing to do
          });
        })
      } else {
        // this.goLoginPage();
        Toast('已退出登录');
      }
    }).catch(() => {
      // on cancel
    });
  },

  /**
   * 判断是否已登录
   * @param {Vue} thisApp
   * @param {Boolean|String} debugLogin 是否调试模式，自动登录，默认false使用微信授权登录 登录oendId: 自动登录，不使用微信授权登录，
   * @param {String} type 登录类型： 1 管局端登录， 2 企业端登录
   * @param {Object} loginExtParams 登录回调URL其它扩展参数
   * @returns {Promise<unknown>}
   */
  checkLogin (thisApp, debugLogin = false, type = null, loginExtParams = null) {
    return new Promise((resolve, reject) => {
      // if (this.getToken()) {
        thisApp.$post('/wechat/checkLogin', {url: commonUtils.getLoginUrl(type, null, loginExtParams)}).then(res => {
          console.log('checkLogin', res);
          // debugger;
          if(res.data){
            // 如果当前页不是登录页并且beforeUrl空，登录前先保存当前地址
            if(window.location.href.indexOf('/index.html') === -1 && !commonUtils.getBeforeLoginUrl()){
              commonUtils.setBeforeLoginUrl(window.location.href);
            }
            // 如果没设置登录类型，并且存在登录后回跳页，则根据登录后回跳页设置登录类型
            if(!type && commonUtils.getBeforeLoginUrl()){
              type = this.getLoginType();
            }
            if(commonUtils.isWeiXin()){
              // Toast("微信授权登录处理中...")
              Toast.loading({
                message: '微信授权登录处理中...',
                forbidClick: true,
              })
              if(debugLogin){
                // 调试模式，自动登录
                commonUtils.goPage(commonUtils.getLoginUrl(type, debugLogin), true);
              }else {
                commonUtils.goPage(res.data, true);
              }
            }else {
              commonUtils.showAlertOpenInWeiXin();
            }
          }else {
            const user = this.getLoginUser()
            if (user) {
              resolve(user)
            } else {
              // console.log('checkLogin reject')
              reject(false)
            }
          }
        }).catch(() => {
          // this.goLoginPage();
          // console.log('checkLogin reject')
          reject(false)
        })
      //} else {
        // console.log('checkLogin reject')
        // reject(false)
      // }
    })
  },
  /**
   * 是否已微信授权获取到OpenId
   * @param {Vue} thisApp
   * @param {String} type 登录类型： 1 管局端登录， 2 企业端登录
   * @returns {Promise<number>} 返回2，表示已登录，返回1表示只有openId, reject获取失败
   */
  isWeiXinAuth(thisApp, type = null) {
    return new Promise((resolve, reject) => {

      let openId = commonUtils.getOpenId();
      console.log("isWeiXinAuth", commonUtils.getOpenId(), this.getToken(),!openId);
      // debugger;
      // 用户登录过或者OpenID不存在，
      if(this.getToken() || !openId){
        // commonUtils.setBeforeLoginUrl(window.location.href);
        this.checkLogin(thisApp, false, type).then(()=>{
          commonUtils.clearBeforeLoginUrl();
          resolve(2);
          // if(user.isAdminUser()){e
          //   // this.$toast('已加入管局用户');
          //   this.$toast({
          //     message: '已加入管局用户',
          //     onClose: ()=>{
          //       user.goUserHomePage();
          //     }
          //   });
          // }else {
          //   this.initPage();
          // }
        }).catch(()=>{
          // this.initPage();
          Dialog.alert({
            message: '微信授权登录失败！',
          }).then(() => {
            // on close
            // commonUtils.goLoginPage();
            reject(0);
          });
        });
      }else if(openId){
        resolve(1);
        // this.initPage();
      }
    });
  },
  /**
   * 是否已登录管局用户
   * @returns {boolean}
   */
  isAdminUser(){
    let token = this.getToken();
    return (token.substr(0, 2) === 'M-');
  },
  /**
   * 是否已登录企业用户
   * @returns {boolean}
   */
  isClientUser(){
    let token = this.getToken();
    return (token.substr(0, 2) === 'C-');
  },
  /**
   * 是否已登录订餐用户
   * @returns {boolean}
   */
  isOrderUser(){
    let token = this.getToken();
    return (token.substr(0, 2) === 'O-');
  },
  /**
   * 根据URL返回登录类型
   * @param {String} url 为空时，获取登录后跳转URL
   * @returns {null|String} 登录类型： 1 管局端登录， 2 企业端登录， 3 订餐端登录， null 自动
   */
  getLoginType(url = null) {
    if(!url){
      url = commonUtils.getBeforeLoginUrl();
    }
    if (url) {
      if (commonUtils.isAdminPage(url)) {
        return this.TypeAdmin;
      } else if (commonUtils.isClientPage(url)) {
        return this.TypeClient;
      } else if(commonUtils.isOrderPage(url)){
        return this.TypeOrder;
      }
    }
    return null;
  },
  /**
   *
   * @param {String} type 登录类型： 1 管局端登录， 2 企业端登录
   */
  changeLogin(type){
    Dialog.confirm({
      title: '提示',
      message: '是否确认切换到' + (type === '1' ? '管局' : '企业') + '端',
    }).then(() => {
      this.doChangeLogin(type);
    });
  },
  /**
   *
   * @param {String} type 登录类型： 1 管局端登录， 2 企业端登录
   */
  doChangeLogin(type){
    // doPost('/changeLogin', {type: type}).then(({data})=>{
    //   this.setLoginUser(data);
    //   this.goUserHomePage();
    // });
  },

  /**
   * 跳转到首页或登录前的页面
   * @param {String} type 登录类型： 1 管局端， 2 企业端， 3 订餐端
   */
  goUserHomePage(type = null){
    commonUtils.goPage('./index.html', true);
    // if((type === this.TypeAdmin && !this.isAdminUser()) || (type === this.TypeClient && this.isAdminUser())){
    //   this.doChangeLogin(type);
    //   return;
    // }
    // 先判断是否在存登录前页面
    // if(!commonUtils.goBeforeLoginPage()){
    //   if(this.isAdminUser()) {
    //     commonUtils.goPage('./index.html', true);
    //   }else if(this.isClientUser()) {
    //     commonUtils.goPage('./zqtClient.html', true);
    //   }else if(this.isOrderUser()) {
    //     commonUtils.goPage('./order.html', true);
    //   }
    // }
  },
  
  /**
   * 密码复杂度判断
   * 密码复杂要求： 1、长度大于8
   *             2、密码必须是字母大写，字母小写，数字，特殊字符中任意二个组合。
   * @param s 密码字符串
   * @return {number} 返回 0表示长度不够， 1 弱，只符合1种规则， 2中 符合2种规则， 3强 符合3种规则， 4超强 符合4种规则
   */
  checkPassword(s) {
    if (s.length < 8) {
      return 0;
    }
    let ls = 0;
    if (s.match(/([a-z])+/)) {
      ls++;
    }
    if (s.match(/([0-9])+/)) {
      ls++;
    }
    if (s.match(/([A-Z])+/)) {
      ls++;
    }
    if (s.match(/[^a-zA-Z0-9]+/)) {
      ls++;
    }
    return ls
  },
  /**
   * 弱密码判断
   * @param s
   * @return {boolean}
   */
  checkWeakPassword(s) {
    return this.isWeakPassword(this.checkPassword(s));
  },
  
  /**
   * 弱密码判断
   * @param pswLevel
   * @return {boolean}
   */
  isWeakPassword(pswLevel){
    return pswLevel < 2;
  },
};
